var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('img',{staticStyle:{"width":"128px","margin":"48px 0"},attrs:{"alt":"Vue logo","src":"/favicon.ico"}}),_c('HelloWorld')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }